import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  LocalizedDateFormatPipe,
  LocalizedTimeFormatPipe,
} from '@wilson/localization';

@Component({
  selector: 'wilson-preview-card',
  templateUrl: './preview-card.component.html',
  styleUrls: ['./preview-card.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    LocalizedDateFormatPipe,
    LocalizedTimeFormatPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewCardComponent {
  @Input({ required: true }) startLocation!: string | null;
  @Input({ required: true }) endLocation!: string | null;
  @Input({ required: true }) startDateTime!: Date | string;
  @Input({ required: true }) endDateTime!: Date | string;
  @Input({ required: true }) isTransferCard!: boolean;
}
